import React, { ReactNode } from 'react';

import { cn, Card, CardHeader, CardContent } from 'shadcn-ui';
import { useShowContext } from 'ui-builder';
import { InnerBlockProps } from './InnerBlock';

function BlockTitle(props: {
  headerSize: 1 | 2 | 3 | 4 | 5 | 6,
  children: ReactNode,
}) {
  const Header = `h${props.headerSize}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  return <Header className="!mb-0">{props.children}</Header>;
}

export default function ShadcnInnerBlock(props: InnerBlockProps) {
  const showContext = useShowContext();

  function getTitle() {
    if (typeof props.title !== 'function') {
      return props.title;
    } else {
      return props.title(showContext?.data || {});
    }
  }

  return (
    <Card
      className={cn(
        'border-none rounded-none bg-transparent shadow-none',
        props.className,
      )}
      data-testid={props.testId}
    >
      <CardHeader
        className={cn(
          'flex flex-row items-center justify-between gap-2 mb-3 px-0 py-0',
          props.showHeaderBorder && 'border-b border-border pb-3 mb-6',
        )}
        data-testid={props.testId ? `${props.testId}-header` : undefined}
      >
        <div>
          <BlockTitle headerSize={props.headerSize || 2}>
            {getTitle()}
            {props.count !== undefined && (
              <span className="text-lg text-gray-500 font-normal ml-1">
                ({props.count})
              </span>
            )}
          </BlockTitle>
          {props.titleLine2 && (
            <div className="text-app-body text-gray-500 mt-1">
              {props.titleLine2}
            </div>
          )}
        </div>
        {props.headerRight && (
          <div
            className="flex items-center gap-2 shrink-0"
            data-testid={props.testId ? `${props.testId}-header-right` : undefined}
          >
            {props.headerRight}
          </div>
        )}
      </CardHeader>
      <CardContent className="px-0 py-0">
        {props.children}
      </CardContent>
    </Card>
  );
}
